import { injectable, inject, decorate } from 'inversify'
import { Api } from '@evertel/api'
import { makeAutoObservable } from 'mobx'

interface PasswordValidationInputs {
    password: string
    email?: string
    firstName?: string
    lastName?: string
    phone?: string
}

class PasswordController {
    constructor(
        private api: Api
    ) {
        makeAutoObservable(this)
    }

    /**
     * This should be caught where it's used to handle errors
     * @param data
     * @returns
     */
    async validate(data: PasswordValidationInputs) {
        const response = await this.api.Routes.BlueUser.postCheckPasswordStrength(data as any)
        return response
    }
}
decorate(injectable(), PasswordController)
decorate(inject(Api), PasswordController, 0)
export { PasswordController }
